import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailFieldListComponent } from 'src/app/ui/detail-field-list/detail-field-list.component';
import { DetailFieldsSettingsComponent } from 'src/app/ui/detail-fields-settings/detail-fields-settings.component';
import { IconComponent as UiIconComponent } from 'src/app/ui/icon/icon.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OverlayModule } from '@angular/cdk/overlay';
import { DuplicateBadgeComponent } from './components/duplicate-badge/duplicate-badge.component';
import { ListQuotationsComponent } from './components/list-quotations/list-quotations.component';
import { DetailsQuotesComponent } from './components/details-quotes/details-quotes.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { QuoteRejectComponent } from './components/quote-reject/quote-reject.component';
import { QuoteDocumentComponent } from './components/quote-document/quote-document.component';
import { PreviewQuoteComponent } from './components/preview-quote/preview-quote.component';
import { AddQuotationComponent } from './components/add-quotation/add-quotation.component';
import { EditQuotesComponent } from './components/edit-quotes/edit-quotes.component';
import { ConfirmOrderStatusComponent } from './components/confirm-order-status/confirm-order-status.component';
import { FilterQuotationsComponent } from './components/filter-quotations/filter-quotations.component';
import { GenerateInvoicePopUpComponent } from './components/generate-invoice-pop-up/generate-invoice-pop-up.component';
import { ProductsQuoteComponent } from './components/products-quote/products-quote.component';
import { ProductsQuoteFromCatalogComponent } from './components/products-quote-from-catalog/products-quote-from-catalog.component';
import { OrderStatusConfirmComponent } from './components/order-status-confirm/order-status-confirm.component';
import { EditOrderConditionsComponent } from './components/edit-order-conditions/edit-order-conditions.component';
import { EditCommentComponent } from './components/edit-comment/edit-comment.component';
import { EditCustomerPoNumberComponent } from './components/edit-customer-po-number/edit-customer-po-number.component';
import { DetailsCopilotScoreComponent } from './components/details-copilot-score/details-copilot-score.component';
import { KillStockDetailsComponent } from './components/kill-stock-details/kill-stock-details.component';
import { SourceContentComponent } from './components/source-content/source-content.component';
import { MatchingMissingAiQuoteProductsComponent } from './components/matching-missing-ai-quote-products/matching-missing-ai-quote-products.component';
import { MatchingMissingProductsSelectorComponent } from './components/matching-missing-products-selector/matching-missing-products-selector.component';
import { ProductsAvailabilityDialogComponent } from './components/products-availability-dialog/products-availability-dialog.component';
import { DuplicateProductsHandlerComponent } from './components/duplicate-products-handler/duplicate-products-handler.component';
import { UiModule } from 'src/app/ui/ui.module';
import { ExploreCatalogComponent } from '../new-orders/components/explore-catalogs/explore-catalog.component';
import { CatalogProductDetailsComponent } from './components/catalog-product-details/catalog-product-details.component';
import { PromptToOrderComponent } from './components/prompt-to-order/prompt-to-order.component';
import { OrderCustomFieldsComponent } from './components/order-custom-fields/order-custom-fields.component';
import { ObjectCustomFieldsFormComponent } from 'src/app/shared/components/object-custom-fields-form/object-custom-fields-form.component';
import { SideBySideCorrectionPanelComponent } from './components/side-by-side-correction-panel/side-by-side-correction-panel.component';
import { OrderQuickActionsRowComponent } from './components/side-by-side-correction-panel/order-quick-actions-row/order-quick-actions-row.component';
import { MatDividerModule } from '@angular/material/divider';
import { OrderLineAlertsComponent } from './components/order-line-alerts/order-line-alerts.component';
import { ProductNotesDialogComponent } from './components/product-notes-dialog/product-notes-dialog.component';
import { ExtractedNotesEditorComponent } from './components/extracted-notes-editor/extracted-notes-editor.component';
import { AutofocusDirective } from './components/extracted-notes-editor/autofocus.directive';
import { EmailBodyHighlightDirective } from './components/side-by-side-correction-panel/email-body-highlight.directive';
import { HasPermissionDirective } from 'src/app/shared/has-permission.directive';
import { OrderOwnerPopoverComponent } from '../orders/components/order-owner-popover/order-owner-popover.component';
import { CompanyLocationSelectorComponent } from '../new-orders/components/company-location-selector/company-location-selector.component';
import { ReviewReasonPipe } from 'src/app/core/pipes/review-reason.pipe';
import { OrderHeaderTagsComponent } from './components/order-header-tags/order-header-tags.component';



@NgModule({
  declarations: [
    DuplicateBadgeComponent,
    OrderHeaderTagsComponent,
    ListQuotationsComponent,
    QuoteRejectComponent,
    QuoteDocumentComponent,
    PreviewQuoteComponent,
    AddQuotationComponent,
    EditQuotesComponent,
    ConfirmOrderStatusComponent,
    FilterQuotationsComponent,
    GenerateInvoicePopUpComponent,
    OrderStatusConfirmComponent,
    EditOrderConditionsComponent,
    EditCommentComponent,
    EditCustomerPoNumberComponent,
    DetailsCopilotScoreComponent,
    KillStockDetailsComponent,
    SourceContentComponent,
    MatchingMissingAiQuoteProductsComponent,
    MatchingMissingProductsSelectorComponent,
    ProductsAvailabilityDialogComponent,
    DuplicateProductsHandlerComponent,
    PromptToOrderComponent,
    OrderCustomFieldsComponent,
    SideBySideCorrectionPanelComponent,
    OrderQuickActionsRowComponent,
    OrderLineAlertsComponent,
    ProductNotesDialogComponent,
    ExtractedNotesEditorComponent,
    AutofocusDirective,
    EmailBodyHighlightDirective,
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
    ExploreCatalogComponent,
    ProductsQuoteComponent,
    ObjectCustomFieldsFormComponent,
    HasPermissionDirective,
    MatProgressSpinnerModule,
    OverlayModule,
    CompanyLocationSelectorComponent,
    OrderOwnerPopoverComponent,
    MatDividerModule,
    ReviewReasonPipe,
    // Configurable detail blocks shared with the order detail page (WB-7463).
    DetailFieldListComponent,
    DetailFieldsSettingsComponent,
    UiIconComponent,
  ],
  exports: [
    DuplicateBadgeComponent,
    OrderHeaderTagsComponent,
    ProductsQuoteComponent,
    SourceContentComponent,
    SideBySideCorrectionPanelComponent,
    ExtractedNotesEditorComponent,
  ],
})
export class QuotationsModule {}